import React from "react";
import { Link } from "react-router-dom";
import image1 from "../assets/revolution.jpg";
import image2 from "../assets/abha.jpg";
import image3 from "../assets/image3.png";
import image4 from "../assets/image4.png";
import image5 from "../assets/smart.jpg";
import image6 from "../assets/image6.png";
import image201 from "../assets/image201.png";
import image202 from "../assets/image202.png";
import image203 from "../assets/image203.png";
import image204 from "../assets/image204.png";

const AdvancedAnalyticsCampaignBlog = () => {
  return (
    <div className="min-h-screen w-full font-sans overflow-x-hidden bg-[#d2e5e4] text-black px-4 py-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10">
        {/* Main Blog */}
        <div className="flex-1">
          <img
            src={image3}
            alt="Advanced Analytics and Campaign Management"
            className="w-full h-72 object-cover bg-gray-100 border border-gray-300 rounded-lg mb-6"
          />

          <div className="bg-sky-700 text-white text-3xl font-bold py-4 px-6 rounded mb-8">
            Advanced Analytics & Campaign Management
          </div>

          <div className="space-y-8 text-lg text-black">
            <div>
              <h2 className="text-xl font-semibold mb-2">
                Smarter Decision Making with AI
              </h2>
              <ul className="list-disc list-inside">
                <li>
                  Track patient trends, treatment effectiveness, and resource
                  usage in real-time.
                </li>
                <li>
                  Visual dashboards provide easy-to-understand insights for
                  faster decisions.
                </li>
                <li>
                  Predictive analytics highlight at-risk patients and forecast
                  patient loads.
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                Campaign Management Features
              </h2>
              <ul className="list-disc list-inside">
                <li>
                  Automated SMS/email outreach for regular follow-ups or health
                  reminders.
                </li>
                <li>Segmentation tools for personalized health campaigns.</li>
                <li>
                  Track engagement metrics and refine campaigns based on
                  performance.
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                Enhanced Patient Experience
              </h2>
              <ul className="list-disc list-inside">
                <li>
                  Patients receive relevant, timely communication tailored to
                  their conditions.
                </li>
                <li>
                  Stronger engagement leads to higher retention and improved
                  treatment adherence.
                </li>
                <li>
                  Builds long-term trust with data-driven personalization.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="w-full md:w-1/3 border-t md:border-t-0 md:border-l border-gray-700 pt-10 md:pt-0 md:pl-8">
          <h3 className="text-xl font-semibold mb-6">Recent Blogs</h3>

          {[
            {
              image: image203,
              alt: "CuttingDownPatientReportDeliveryTimewithAIBlog",
              to: "/cuttingdownpatientreportdeliverytimewithaiblog",
              title:
                "Learn more about Cutting Down Patient Report Delivery Time with AI",
            },
            {
              to: "/inpatientoutpatientblog",
              alt: "InPatient and OutPatient Blog",
              title:
                "Explore how MedOps integrates with ABHA IDs, digital health missions, and AI automation to build the future of Indian healthcare",
              image: image2,
            },
            {
              to: "/inventorytrackingblog",
              alt: "Inventory Tracking Blog",
              title:
                "Real-Time Inventory Tracking with MedOps: Smarter Stock, Smarter Care",
              image: image6,
            },
            {
              to: "/hospitalpharmacyintegrationblog",
              alt: "Hospital Pharmacy Integration Blog",
              title:
                "Discover how AI-powered hospital management systems like MedOps reduce paperwork, improve staff efficiency, and enable data-driven decisions",
              image: image5,
            },
            {
              image: image201,
              alt: "PredictiveAnalyticsBlog",
              to: "/predictiveanalyticsblog",
              title: " Learn more about Predictive Analytics ",
            },
            {
              to: "/diagnosticlabintegrationblog",
              alt: "Diagnostic Lab Integration Blog",
              title:
                "AI-Powered Diagnostic Report Generation & Lab Integration",
              image: image4,
            },
            {
              to: "/voiceprescriptionblog",
              alt: "Voice Prescription Blog",
              title:
                "Learn how MedOps uses AI for real-time monitoring, cloud-based records, and decision support to enhance patient care",
              image: image1,
            },
            {
              image: image202,
              alt: "BestHMSforYourHospitalBlog",
              to: "/besthmsforyourhospitalblog",
              title: "Learn more about Best HMS for Your Hospital ",
            },
                 {
                                      image: image204,
                                      alt: "MedicineForecastingBlog",
                                      to: "/medicineforecastingblog",
                                      title: " Learn more about Medicine Forecasting ",
                                    },
          ].map((blog, idx) => (
            <div key={idx} className="mb-6">
              <Link
                to={blog.to}
                className="flex flex-col gap-2 hover:opacity-90"
              >
                <img
                  src={blog.image}
                  alt={blog.alt}
                  className="w-full h-54 object-cover bg-gray-100 border border-gray-300 rounded"
                />
                <span className="text-sky-600 font-semibold text-sm">
                  {blog.title}
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdvancedAnalyticsCampaignBlog;
